
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M15.394 20.343L32 36.95v23.677L14.222 42.849H0V21.516h14.222l1.172-1.173zM32 3.738v23.314L20.343 15.395 32 3.738zM50.595 55.544l1.423 1.423a31.879 31.879 0 01-13.017 6.265v-2.053a29.889 29.889 0 0011.594-5.635zM39.001.768C53.307 3.961 64 16.732 64 32a31.865 31.865 0 01-7.032 20.017l-1.424-1.423A29.872 29.872 0 0062 32c0-14.158-9.807-26.025-22.999-29.179V.768z"}}),_c('path',{attrs:{"d":"M42.732 47.68l1.436 1.437a20.938 20.938 0 01-5.167 2.688v-2.136a18.951 18.951 0 003.731-1.988zm-3.73-35.485C47.156 15.08 53 22.857 53 32c0 4.535-1.438 8.735-3.883 12.168l-1.436-1.437A18.912 18.912 0 0051 32c0-8.021-4.97-14.881-11.999-17.669v-2.136zM5.657 2.12l56.568 56.57-3.535 3.535L2.12 5.656z"}})])])
          )
        }
      }
    